/**
 * Polyfill for :focus-visible pseudo-element. Currently locked behind Chrome experimental flag.
 * Allows for keyboard-only focused event instead of :focus which captures both keyboard and mouse.
 */
import 'focus-visible';
import * as React from 'react';
import './focus-visible-polyfill.scss';

import {ClassNameBuilder} from '../../../utils/ClassNameBuilder';

import Styles from './Button.module.scss';

export enum ButtonColor {
    primary = 'primary',
    secondary = 'secondary',
    success = 'success',
    danger = 'danger',
    warning = 'warning',
    text = 'text'
}

interface Props extends Omit<React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, 'color'> {
    disabled?: boolean;
    className?: string;
    block?: boolean;
    dataId?: string;
    color?: (keyof typeof ButtonColor) | ButtonColor;
    /**
     * Display as a text button.
     *
     * @default false
     */
    text?: boolean;
}

export const Button: React.FC<Props> = (props) => {
    const {color = ButtonColor.primary, text, block, disabled, className, dataId, children, ...rest} = props;
    const containerClass = new ClassNameBuilder(Styles)
        .add(Styles.button)
        .add(color as string)
        .add([Styles.disabled, disabled])
        .add([Styles.block, block])
        .add([Styles.textButton, text])
        .add([Styles.pillButton, !text])
        .add(className)
        .toString();

    return (
        <button
            className={containerClass}
            disabled={disabled}
            data-id={dataId}
            {...rest}
        >
            {children}
        </button>
    );
};
